import React from "react";

export const useVersion = () =>
	process.env.REACT_APP_GIT_TAG !== ""
		? process.env.REACT_APP_GIT_TAG
		: process.env.REACT_APP_GIT_HASH;
